module.exports = {
	"classes": [
		"lock-page",
		"header-dark"
	],
	"title": "Lock",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/lock/metadata.json
// module id = 1128
// module chunks = 0